function formatMathDecimal(number) {
    var numReg = /^[\+\-]?\d*?\.?\d*?$|^([^0][0-9]+|0)$/
    var numRe = new RegExp(numReg)
    if (!numRe.test(number)) {
        return false
    }
    return true
}

export default formatMathDecimal